/* Sfondo in movimento "fumo": volute disegnate su una tela piccola e ingrandita.
   Un campo di rumore condiviso, letto piu' volte con scorrimenti diversi (deformazione),
   piu' una mappa larga che decide dove il fumo c'e' e dove no: e' quella che gli da' la forma.
   Ricette: vapore, oro, velo, scia, nebbia, soffio. La stella e' solo CSS, non passa di qui. */
(function () {
  var S = 256, F = null, IST = [], vivo = false, ultimo = 0, ultimoT = 0;
  var fermo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cr(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }
  function ss(a, b, x) { var t = (x - a) / (b - a); t = t < 0 ? 0 : t > 1 ? 1 : t; return t * t * (3 - 2 * t); }

  var RICETTE = {
    vapore: { base: [255,250,236], tinta: [190,138,64], sx: 2.2, sy: 2.2, det: 4.6, wsc: 1.0, ric: .62, sal: .055, der: .004, gsc: .55, g0: .30, g1: .72,
      curva: function (n, u, v) { return Math.pow(cr(1 - Math.abs(2 * n - 1)), 1.5) * .95 * (0.35 + 0.8 * v); } },
    oro: { base: [250,232,190], tinta: [168,113,44], sx: 1.45, sy: 1.45, det: 3.0, wsc: .8, ric: .90, sal: .026, der: .006, gsc: .50, g0: .22, g1: .80,
      curva: function (n, u, v) { return Math.pow(ss(.30, .85, n), 1.1) * (0.5 + 0.6 * v); } },
    velo: { base: [248,244,232], tinta: [176,158,116], sx: 1.05, sy: 1.05, det: 2.0, wsc: .6, ric: .40, sal: .010, der: .022, gsc: .45, g0: .18, g1: .85,
      curva: function (n, u, v) { return ss(.28, .90, n) * .55; } },
    scia: { base: [255,246,224], tinta: [178,124,48], sx: 2.8, sy: 1.6, det: 5.4, wsc: 1.15, ric: .75, sal: .085, der: .002,
      curva: function (n, u, v) { var b = Math.exp(-Math.pow((u - .74) / .20, 2)); return Math.pow(cr(1 - Math.abs(2 * n - 1)), 1.4) * b * (0.18 + 1.05 * v); } },
    nebbia: { base: [252,242,218], tinta: [150,104,46], sx: 1.30, sy: .90, det: 2.6, wsc: .7, ric: 1.0, sal: .015, der: .010, gsc: .40, g0: .06, g1: .96,
      curva: function (n, u, v) { return ss(.18, .80, n) * (0.74 + 0.46 * v); } },
    soffio: { base: [253,246,228], tinta: [186,143,72], sx: 1.15, sy: 2.4, det: 2.4, wsc: .9, ric: .60, sal: .011, der: .0015, gsc: .50, g0: .12, g1: .92,
      curva: function (n, u, v) { return Math.pow(cr(1 - Math.abs(2 * n - 1)), 1.3) * .85; } }
  };
  RICETTE.grigio = { base: [255,255,255], tinta: [148,148,152], sx: 1.15, sy: .85, det: 2.3, wsc: .65, ric: 1.0, sal: .010, der: .006, gsc: .38, g0: .05, g1: .97, gmin: .45,
    curva: function (n, u, v) { return ss(.16, .84, n) * (0.86 + 0.46 * v); } };
  RICETTE.notte = { base: [20,16,14], tinta: [236,234,231], sx: 1.25, sy: .88, det: 2.5, wsc: .72, ric: 1.0, sal: .034, der: .015, gsc: .40, g0: .08, g1: .95,
    curva: function (n, u, v) { return ss(.22, .84, n) * (0.34 + 0.78 * v); } };
  RICETTE.bordeaux = { base: [36,12,20], tinta: [250,222,172], sx: 1.25, sy: .88, det: 2.5, wsc: .72, ric: 1.0, sal: .034, der: -.015, gsc: .40, g0: .08, g1: .95,
    curva: function (n, u, v) { return ss(.20, .82, n) * (0.40 + 0.82 * v); } };
  RICETTE.ambra = { base: [64,34,18], tinta: [238,197,128], sx: 1.22, sy: .90, det: 2.4, wsc: .70, ric: 1.0, sal: .026, der: .012, gsc: .40, g0: .08, g1: .95, gmin: .40,
    curva: function (n, u, v) { return ss(.22, .84, n) * (0.40 + 0.72 * v); } };
  /* Quattro grigi identici tranne che per la direzione del movimento.
     sal positivo scende, negativo sale. der positivo entra da destra, negativo da sinistra. */
  (function () {
    var versi = { 'grigio-giu': [.020, 0], 'grigio-su': [-.020, 0], 'grigio-sx': [0, -.020], 'grigio-dx': [0, .020],
                  'grigio-diag': [.032, -.032], 'grigio-diag2': [-.032, .032] };
    for (var k in versi) {
      RICETTE[k] = { base: [245,245,245], tinta: [178,178,183], sx: 1.10, sy: .95, det: 2.2, wsc: .62, ric: 1.0,
        sal: versi[k][0], der: versi[k][1], gsc: .36, g0: .06, g1: .96, gmin: .42,
        curva: function (n, u, v) { return ss(.16, .84, n) * 0.98; } };
    }
  })();
  /* Strisce in diagonale: il rumore viene allungato lungo un asse e stretto
     sull'altro, dentro un sistema di assi ruotato. Zone dense e zone quiete. */
  RICETTE.strisce = { base: [255,255,255], tinta: [166,68,82], rot: -0.62,
    sx: 0.60, sy: 3.80, det: 5.2, wsc: .40, ric: .30, sal: .012, der: -.012,
    gsc: 2.80, g0: .16, g1: .88, gmin: .03, morbida: true,
    curva: function (n, u, v) { return Math.pow(ss(.30, .72, n), 0.85); } };
  /* Su schermo stretto le strisce scorrono da destra verso sinistra
     e sono meno inclinate, perche' la colonna e' una sola. */
  RICETTE['strisce-stretto'] = { base: [255,255,255], tinta: [166,68,82], rot: -0.30,
    sx: 0.65, sy: 3.30, det: 4.6, wsc: .40, ric: .30, sal: .002, der: .014,
    gsc: 2.80, g0: .16, g1: .88, gmin: .03, morbida: true,
    curva: function (n, u, v) { return Math.pow(ss(.30, .72, n), 0.85); } };
  /* Spruzzo: il rumore vive in coordinate polari attorno a un punto e scorre
     verso l'esterno, dentro un cono. Sembra un getto che si apre, non strisce. */
  RICETTE.spruzzo = { base: [255,255,255], tinta: [166,68,82], spruzzo: true,
    ox: .30, oy: .56, dir: -1.05, apertura: 1.75,
    ang: 11, rad: 6.4, ang2: 23, rad2: 17, vel: .052,
    raggio: 1.15, gmin: .07, onda: 2, esp: .80, gran: 130, granq: .62,
    curva: function (n) { return Math.pow(ss(.30, .74, n), 1.15); } };
  RICETTE['spruzzo-stretto'] = { base: [255,255,255], tinta: [166,68,82], spruzzo: true,
    ox: .70, oy: .40, dir: -2.10, apertura: 1.75,
    ang: 11, rad: 5.8, ang2: 23, rad2: 15, vel: .048,
    raggio: 1.30, gmin: .07, onda: 2, esp: .82, gran: 115, granq: .60,
    curva: function (n) { return Math.pow(ss(.30, .74, n), 1.15); } };
  var ALIAS = { avorio: 'vapore' };

  function h2(x, y, s) {
    var h = Math.imul(x | 0, 374761393) ^ Math.imul(y | 0, 668265263) ^ Math.imul(s | 0, 1274126177);
    h = Math.imul(h ^ (h >>> 13), 1274126177);
    return ((h ^ (h >>> 16)) >>> 0) / 4294967295;
  }
  function vn(x, y, c, s) {
    var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
    var u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
    var x0 = ((xi % c) + c) % c, y0 = ((yi % c) + c) % c, x1 = (x0 + 1) % c, y1 = (y0 + 1) % c;
    var a = h2(x0, y0, s), b = h2(x1, y0, s), cc = h2(x0, y1, s), d = h2(x1, y1, s);
    var t = a + (b - a) * u;
    return t + ((cc + (d - cc) * u) - t) * v;
  }
  /* Il campo di rumore e' sempre lo stesso: calcolato una volta, resta nel browser
     (16 bit bastano, l'errore e' invisibile). Cambiando pagina non si ricalcola. */
  var CHIAVE = 'apFumoCampo1';
  function leggiCampo() {
    try {
      var t = localStorage.getItem(CHIAVE);
      if (!t || t.length !== S * S * 2) return null;
      var f = new Float32Array(S * S);
      for (var i = 0, j = 0; i < f.length; i++, j += 2) f[i] = ((t.charCodeAt(j) << 8) | t.charCodeAt(j + 1)) / 65535;
      return f;
    } catch (e) { return null; }
  }
  function salvaCampo(f) {
    try {
      var parti = [], blocco = [];
      for (var i = 0; i < f.length; i++) {
        var q = Math.round(f[i] * 65535);
        blocco.push(q >> 8, q & 255);
        if (blocco.length >= 8192) { parti.push(String.fromCharCode.apply(null, blocco)); blocco = []; }
      }
      parti.push(String.fromCharCode.apply(null, blocco));
      localStorage.setItem(CHIAVE, parti.join(''));
    } catch (e) {}
  }
  function campo() {
    if (F) return F;
    var letto = leggiCampo();
    if (letto) { F = letto; return F; }
    var f = new Float32Array(S * S), mn = 1e9, mx = -1e9, i = 0;
    for (var y = 0; y < S; y++) for (var x = 0; x < S; x++) {
      var v = 0, a = 0.5, c = 3;
      for (var o = 0; o < 6; o++) { v += a * vn(x / S * c, y / S * c, c, 11 + o * 29); c *= 2; a *= 0.5; }
      if (v < mn) mn = v; if (v > mx) mx = v; f[i++] = v;
    }
    var d = mx - mn || 1;
    for (i = 0; i < f.length; i++) f[i] = (f[i] - mn) / d;
    F = f; salvaCampo(f); return f;
  }
  function sp(x, y) {
    x -= Math.floor(x); y -= Math.floor(y);
    var fx = x * S, fy = y * S, x0 = fx | 0, y0 = fy | 0, tx = fx - x0, ty = fy - y0;
    var x1 = (x0 + 1) % S, y1 = (y0 + 1) % S, r0 = y0 * S, r1 = y1 * S;
    var a = F[r0 + x0], b = F[r0 + x1], c = F[r1 + x0], d = F[r1 + x1];
    var t = a + (b - a) * tx;
    return t + ((c + (d - c) * tx) - t) * ty;
  }

  /* Una tinta scelta a mano, smorzata verso il neutro: il vapore prende il colore
     del prodotto senza mai diventare acceso. */
  function tinta(hex, r) {
    if (!hex) return null;
    hex = String(hex).trim().replace('#', '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    if (!/^[0-9a-fA-F]{6}$/.test(hex)) return null;
    var c = [parseInt(hex.slice(0, 2), 16), parseInt(hex.slice(2, 4), 16), parseInt(hex.slice(4, 6), 16)];
    var g = (c[0] * 0.2126 + c[1] * 0.7152 + c[2] * 0.0722);
    var q = 0.05;                       // quanto si smorza verso il grigio
    var out = [];
    for (var i = 0; i < 3; i++) {
      /* deve restare piu' scura del fondo bianco, altrimenti non si vede */
      var v = (c[i] * (1 - q) + g * q) * 0.86;
      out.push(Math.max(0, Math.min(255, Math.round(v))));
    }
    return out;
  }

  var STRETTO = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function ricetta(el) {
    var chiave = el.getAttribute('data-fumo');
    var alt = el.getAttribute('data-fumo-stretto');
    if (alt && STRETTO && STRETTO.matches) chiave = alt;
    return RICETTE[chiave] || RICETTE[ALIAS[chiave]] || RICETTE.nebbia;
  }
  /* girando il telefono o allargando la finestra si cambia ricetta */
  if (STRETTO && STRETTO.addEventListener) {
    STRETTO.addEventListener('change', function () {
      for (var i = 0; i < IST.length; i++) {
        IST[i].r = ricetta(IST[i].el);
        IST[i].dipinto = false;
        pinta(IST[i], IST[i].sf);
      }
    });
  }

  function misura(o) {
    var b = o.el.getBoundingClientRect();
    if (!b.width || !b.height) return false;
    /* pixel sempre quadrati: si tiene il rapporto e si taglia sul totale */
    var q = 2.2, w = b.width / q, h = b.height / q;
    if (w * h > 104000) { var k = Math.sqrt(104000 / (w * h)); w *= k; h *= k; }
    w = Math.max(80, Math.round(w)); h = Math.max(60, Math.round(h));
    /* il rumore deve avere la stessa scala nei due sensi, altrimenti su una
       fascia larga sembra un'immagine stirata in orizzontale */
    o.ar = Math.max(1, Math.min(4.5, b.width / b.height));
    /* e su una fascia alta e stretta (telefono) si alza la frequenza verticale, altrimenti esce tirato in altezza */
    o.av = Math.max(1, Math.min(4.5, b.height / b.width));
    if (w === o.w && h === o.h) return true;
    o.w = w; o.h = h; o.cv.width = w; o.cv.height = h; o.img = o.ctx.createImageData(w, h);
    /* piu' e' ingrandito, piu' si ammorbidisce: cosi' non si vedono i quadretti */
    var up = b.width / w;
    o.cv.style.setProperty('--ap-fumo-sfoca', Math.min(2.2, Math.max(0.6, up * 0.45)).toFixed(2) + 'px');
    return true;
  }
  function pinta(o, t) {
    if (!F) return;
    if (!o.img && !misura(o)) return;
    var r = o.r, d = o.img.data, w = o.w, h = o.h, i = 0;
    var sal = t * r.sal, der = t * r.der, a1 = r.base, a2 = o.tinta || r.tinta, usaG = r.gsc !== undefined;
    /* su una fascia molto larga si alza la frequenza orizzontale, altrimenti il fumo esce tirato */
    var ar = o.ar || 1, sc = o.scala || 1;
    var fx = r.sx * ar / sc, fdet = r.det * ar / sc, fw = r.wsc * ar / sc, fg = (r.gsc || 0) * ar / sc, k = o.k;
    var av = o.av || 1;
    var fsy = r.sy * av / sc, fdety = r.det * av / sc, fwy = r.wsc * av / sc, fgy = (r.gsc || 0) * av / sc;
    var ro = r.rot || 0, cs = Math.cos(ro), sn = Math.sin(ro);
    if (r.spruzzo) { spruzza(o, r, t, d, w, h); o.ctx.putImageData(o.img, 0, 0); o.dipinto = true; return; }
    for (var y = 0; y < h; y++) {
      var v0 = y / h;
      for (var x = 0; x < w; x++) {
        var u = x / w;
        var v = v0;
        if (ro) { var _u = u * cs - v0 * sn; v = u * sn + v0 * cs; u = _u; }
        var wx = sp(u * fw + der, v * fwy - sal * .55) - .5;
        var wy = sp(u * fw + 4.13, v * fwy + 2.71 - sal * .55) - .5;
        var n = sp(u * fx + wx * r.ric + der, v * fsy - sal + wy * r.ric);
        n = n * .62 + sp(u * fdet + wx * r.ric * 1.7 + der * 1.6, v * fdety - sal * 1.8 + wy * r.ric * 1.7) * .38;
        var a = r.curva(n, u, v0) * k;
        if (usaG) {
          var gm = r.gmin === undefined ? .38 : r.gmin;
          var G = sp(u * fg + der * .6 + 9.1, v * fgy - sal * .45 + 3.3);
          /* niente soglia netta: il valore del velo passa quasi intero, cosi'
             ogni gruppo di nuvole ha una sua intensita' diversa dalle altre */
          var gv = r.morbida ? Math.pow(ss(r.g0, r.g1, G), 1.6) : ss(r.g0, r.g1, G);
          a *= gm + (1 - gm) * gv;
        }
        a = a < 0 ? 0 : a > 1 ? 1 : a;
        d[i] = a1[0] + (a2[0] - a1[0]) * a;
        d[i + 1] = a1[1] + (a2[1] - a1[1]) * a;
        d[i + 2] = a1[2] + (a2[2] - a1[2]) * a;
        d[i + 3] = a * 255;
        i += 4;
      }
    }
    o.ctx.putImageData(o.img, 0, 0);
    o.dipinto = true;
  }

  /* getto che si apre da un punto: rumore in raggio e angolo, che scorre verso fuori */
  function spruzza(o, r, t, d, w, h) {
    var ar = o.ar || 1, k = o.k, i = 0;
    var a1 = r.base, a2 = o.tinta || r.tinta;
    var gm = r.gmin === undefined ? .05 : r.gmin;
    var scorre = t * r.vel;
    for (var y = 0; y < h; y++) {
      var dy = y / h - r.oy;
      for (var x = 0; x < w; x++) {
        var dx = (x / w - r.ox) * ar;
        var rad = Math.sqrt(dx * dx + dy * dy);
        var th = Math.atan2(dy, dx);
        var an = th / 6.28318 + 0.5;
        /* moltiplicatori interi sull'angolo: il rumore si richiude senza cucitura */
        /* il getto si allarga mentre va: piu' lontano, piu' le volute si stirano */
        var rr = Math.pow(rad, 0.70);
        var n = sp(an * r.ang, rr * r.rad - scorre);
        n = n * .62 + sp(an * r.ang2 + 2.3, rr * r.rad2 - scorre * 1.9) * .38;
        var a = r.curva(n) * k;
        /* sbuffi che partono dall'ugello e corrono verso fuori */
        var onda = 0.5 + 0.5 * Math.cos(rad * (r.onda || 3) - scorre * 6.28318);
        a *= 0.45 + 0.55 * onda;
        /* grana di goccioline sospese: e' questa che fa la nebbia atomizzata */
        if (r.gran) {
          var gr = sp(x / w * r.gran + scorre * .4, y / h * r.gran * 1.35 - scorre * 2.2);
          a *= (1 - r.granq) + r.granq * (0.35 + 1.30 * gr);
        }
        /* si spegne allontanandosi dal punto di partenza */
        var q = rad / r.raggio;
        a *= Math.exp(-q * q * 1.6);
        /* e resta dentro il cono del getto */
        var da = th - r.dir;
        while (da > 3.14159) da -= 6.28318;
        while (da < -3.14159) da += 6.28318;
        var cono = Math.cos(da / r.apertura * 1.5708);
        a *= gm + (1 - gm) * (cono > 0 ? cono * cono : 0);
        a = a < 0 ? 0 : a > 1 ? 1 : a;
        d[i] = a1[0] + (a2[0] - a1[0]) * a;
        d[i + 1] = a1[1] + (a2[1] - a1[1]) * a;
        d[i + 2] = a1[2] + (a2[2] - a1[2]) * a;
        d[i + 3] = a * 255;
        i += 4;
      }
    }
  }

  function giro(now) {
    if (!vivo) return;
    requestAnimationFrame(giro);
    if (now - ultimo < 45) return;
    ultimo = now;
    /* ogni vapore ha il suo orologio che avanza solo quando si vede: quando torna in vista riparte da dove era, senza salti */
    var dt = ultimoT ? Math.min(0.1, (now - ultimoT) / 1000) : 0.045;
    ultimoT = now;
    for (var i = 0; i < IST.length; i++) {
      var o = IST[i];
      if (!o.vista || o.statico) continue;
      o.orologio = (o.orologio === undefined ? o.sf : o.orologio) + dt;
      pinta(o, o.orologio);
    }
  }
  function accendi() {
    var serve = !document.hidden && !fermo && IST.some(function (o) { return o.vista && !o.statico; });
    if (serve && !vivo) { vivo = true; requestAnimationFrame(giro); }
    else if (!serve) vivo = false;
  }
  /* Si dipingono solo i vapori in vista (o quasi), uno per fotogramma: niente
     blocchi lunghi al caricamento. Gli altri si dipingono quando arrivano in vista. */
  var coda = [], inCoda = false;
  function metti(o) {
    if (o.dipinto || o.inCoda) return;
    o.inCoda = true; coda.push(o);
    if (!inCoda) { inCoda = true; requestAnimationFrame(svuota); }
  }
  function svuota() {
    var o = coda.shift();
    if (o) { o.inCoda = false; if (o.vista && !o.dipinto) { pinta(o, o.orologio === undefined ? o.sf : o.orologio); if (!o.dipinto) setTimeout(function () { metti(o); }, 240); } }
    if (coda.length) requestAnimationFrame(svuota); else inCoda = false;
  }
  function tutte() {
    for (var i = 0; i < IST.length; i++) if (IST[i].vista) metti(IST[i]);
  }
  function prepara() {
    if (!F) campo();
    tutte();
    accendi();
  }

  function avvia() {
    var nodi = document.querySelectorAll('.ap-fumo[data-fumo]:not([data-pronto])');
    if (!nodi.length) return;
    for (var i = 0; i < nodi.length; i++) {
      var el = nodi[i], cv = el.querySelector('.ap-fumo__c');
      if (!cv) continue;
      var ctx = cv.getContext('2d');
      if (!ctx) continue;
      var r = ricetta(el);
      el.setAttribute('data-pronto', '1');
      var o = { el: el, cv: cv, ctx: ctx, w: 0, h: 0, img: null, r: r, ar: 1, k: (parseFloat(el.getAttribute('data-forza')) || 100) / 100,
        tinta: tinta(el.getAttribute('data-tinta'), r),
        scala: Math.max(0.4, Math.min(4, parseFloat(el.getAttribute('data-scala')) || 1)),
        vista: !window.IntersectionObserver, dipinto: false, sf: (IST.length * 5.3) % 40, statico: true };
      /* fermo ovunque per velocita': il disegno resta identico, non si ridisegna di continuo (la nebbia della scheda prodotto e' un altro script) */
      IST.push(o); el.__f = o; misura(o);
      if (window.IntersectionObserver) new IntersectionObserver(function (e) { var x = e[0].target.__f; if (x) { x.vista = e[0].isIntersecting; if (x.vista && !x.dipinto && F) metti(x); accendi(); } }, { rootMargin: '600px 0px' }).observe(el);
      if (window.ResizeObserver) new ResizeObserver(function (e) { var x = e[0].target.__f; if (!x) return; var pw = x.w, ph = x.h; if (misura(x) && (x.w !== pw || x.h !== ph || !x.dipinto)) { if (x.vista) pinta(x, x.orologio === undefined ? x.sf : x.orologio); else x.dipinto = false; } }).observe(el);
    }
    if (F) prepara();
    else if (window.requestIdleCallback) requestIdleCallback(prepara, { timeout: 700 });
    else setTimeout(prepara, 200);
  }

  /* Un vapore che svanisce da solo smette anche di disegnare, non resta a girare a vuoto. */
  document.addEventListener('animationend', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('ap-svanisce')) return;
    var f = el.querySelector('.ap-fumo');
    if (f && f.__f) f.__f.vista = false;
    el.style.display = 'none';
    accendi();
  });

  document.addEventListener('visibilitychange', accendi);
  document.addEventListener('shopify:section:load', avvia);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
